/**
 * Invite tracking inside a rave host (`lib/inviteTracking.ts`). Rendered once
 * by `RaveHost`, signed in or out: it remembers an arriving `?invite=` code,
 * reports the open once the session is known (so the inviter's own visit is
 * recognised), and hands the code over once somebody let in is signed in.
 * Draws nothing and blocks nothing.
 */
import { useEffect, useState } from 'react';
import { useAuth } from './AuthProvider';
import { claimPendingInvite, noteInviteArrival, reportInviteOpen } from '@/lib/inviteTracking';

export function InviteTracking({ editionId }: { editionId: string }) {
  const { user, loading, offline } = useAuth();
  // Read the address once, at mount — before anything can navigate away from it.
  const [code] = useState(() => noteInviteArrival());
  useEffect(() => { if (!loading && code) reportInviteOpen(code); }, [loading, code]);
  const letIn = Boolean(user && (user.approved || user.role === 'SUPER_ADMIN') && !offline);
  useEffect(() => { if (letIn) void claimPendingInvite(editionId); }, [letIn, editionId]);
  return null;
}
